export const FONTS = [
  { value: "AlrightSans-Black", text: "Alright Sans-Black" },
  { value: "Apercu", text: "Apercu" },
  { value: "Arbutus Slab", text: "Arbutus Slab" },
  { value: "Arial", text: "Arial" },
  { value: "Arial Black", text: "Arial Black" },
  { value: "ArialNarrow", text: "Arial Narrow" },
  { value: "Arial Rounded MT Bold", text: "Arial Rounded MT Bold" },
  { value: "Avenir LT Std", text: "Avenir-Book" },
  { value: "AvenirNextLTPro-Regular", text: "AvenirNextLTPro-Regular" },
  { value: "Barlow-Medium", text: "Barlow Medium" },
  { value: "Baskerville Old Face", text: "Baskerville Old Face" },
  { value: "BebasNeue-Bold", text: "BebasNeue Bold" },
  { value: "Blackside", text: "Blackside" },
  { value: "Bodoni MT", text: "Bodoni MT" },
  { value: "Book Antiqua", text: "Book Antiqua" },
  { value: "Brush Script MT", text: "Brush Script MT" },
  { value: "Calibri", text: "Calibri" },
  { value: "Calisto MT", text: "Calisto MT" },
  { value: "Cambria", text: "Cambria" },
  { value: "Candara", text: "Candara" },
  { value: "Century Gothic", text: "Century Gothic" },
  { value: "Consolas", text: "Consolas" },
  { value: "Copperplate Gothic Light", text: " Copperplate Gothic Light" },
  { value: "Courier New", text: "Courier New" },
  { value: "Cronus Round", text: "Cronus Round" },
  { value: "Dezen Solid", text: "Dezen Solid" },
  { value: "Eurostile", text: "Eurostile" },
  { value: "FjallaOne-Regular", text: "Fjalla One" },
  { value: "Franklin Gothic Medium", text: " Franklin Gothic Medium" },
  { value: "Futura-Medium", text: " Futura Medium" },
  { value: "Garamond", text: "Garamond" },
  { value: "Gentona-Book", text: "Gentona Book" },
  { value: "Georgia", text: "Georgia" },
  { value: "Gill Sans", text: " Gill Sans" },
  { value: "Gotham Black", text: "Gotham Black Regular" },
  { value: "Goudy Old Style", text: "Goudy Old Style" },
  { value: "HKGrotesk-Regular", text: "Hanken Grotesk" },
  { value: "Helvetica", text: "Helvetica" },
  { value: "HelveticaNeue-Bold", text: "Helvetica Neue Bold" },
  { value: "Hoefler Text", text: " Hoefler Text" },
  { value: "Impact", text: "Impact" },
  { value: "Industry Inc", text: "Industry Inc" },
  { value: "JuliusSansOne-Regular", text: "Julius Sans One" },
  { value: "Kano", text: "Kano" },
  { value: "KabelLTStd-Heavy", text: " KabelLTStd-Heavy" },
  { value: "Lato", text: "Lato" },
  { value: "LeagueSpartan-Bold", text: "League Spartan Bold" },
  { value: "Look Sans", text: " Look Sans" },
  { value: "Lucida Bright", text: "Lucida Bright" },
  { value: "Lucida Console", text: "Lucida Console" },
  { value: "Lucida Sans Typewriter", text: "Lucida Sans Typewriter" },
  { value: "Lucida Grande", text: "Lucida Grande" },
  { value: "MarlonPro-Medium", text: "MarlonPro Medium" },
  { value: "Montserrat-Bold", text: "Montserrat Bold" },
  { value: "NeueAachenPro-Light", text: "Neue Aachen Pro Light" },
  {
    value: "NeueHelveticaW04-69CmMd",
    text: "Neue Helvetica Pro 69 Compressed Medium",
  },
  { value: "NunitoSans-Regular", text: "Nunito Sans Regular" },
  { value: "Open Sans", text: "Open Sans" },
  { value: "Optima", text: "Optima" },
  { value: "Oswald-Regular", text: "Oswald Regular" },
  { value: "Palatino", text: "Palatino" },
  { value: "Papyrus", text: "Papyrus" },
  { value: "Perpetua", text: "Perpetua" },
  { value: "Poppins-Regular", text: "Poppins Regular" },
  { value: "ProximaNova-Medium", text: "Proxima Nova Medium" },
  { value: "PTSans-Bold", text: "PT Sans Bold" },
  { value: "PTSans-Narrow", text: "PT Sans Narrow" },
  { value: "PTSans-Regular", text: "PT Sans Regular" },
  { value: "Raleway-Bold", text: "Raleway Bold" },
  { value: "Raleway-Light", text: "Raleway Light" },
  { value: "Relative", text: "Relative Book" },
  { value: "Rhinos rocks", text: "Rhinos Rocks" },
  { value: "Roboto Condensed", text: "Roboto Condensed Light" },
  { value: "Rockwell", text: "Rockwell" },
  { value: "Segoe UI", text: "Segoe UI" },
  { value: "Somatic-Rounded", text: "Somatic Rounded" },
  { value: "Square721 BdEx BT", text: "Square721 BdEx BT" },
  { value: "Tahoma", text: "Tahoma" },
  { value: "Times New Roman", text: "Times New Roman" },
  { value: "Trebuchet MS", text: "Trebuchet MS" },
  { value: "Verdana", text: "Verdana" },
]
